import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { saveShowSenderInGridStatus } from 'flow/actions/video-actions';
import { selectVideoShowSenderInGridStatus } from 'flow/selectors/video-selectors';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';

/**
 * Corner control on the self-view tile: docks the camera in and out of the grid
 * (in-grid tile <-> floating corner PiP). Reveals on hover of the tile's
 * `group` container. Owns its own show-in-grid state, so the tile just drops it
 * in without wiring.
 */
const SelfViewDockToggle: React.FC = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const shouldShowSenderInGrid = useAppSelector(
        selectVideoShowSenderInGridStatus,
    );

    return (
        <button
            type="button"
            className="group-focus-visible-within:opacity-100 absolute end-2 top-2 z-[12] flex items-center justify-center rounded-full bg-gray-100 p-2 text-gray-900 opacity-0 transition-opacity group-hover:opacity-100 hover:cursor-pointer"
            onClick={() =>
                dispatch(saveShowSenderInGridStatus(!shouldShowSenderInGrid))
            }
            aria-label={i18next.t(
                shouldShowSenderInGrid
                    ? 'videoconference.self_view.minimize'
                    : 'videoconference.self_view.expand',
            )}
        >
            <Icon
                iconKey={
                    shouldShowSenderInGrid
                        ? 'minimize'
                        : 'picture_in_picture_alt'
                }
                size="1.25rem"
            />
        </button>
    );
};

export default SelfViewDockToggle;
